// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupBorder {
  border: 1px solid lightgray;
  border-radius: 4px;
  margin-bottom: 4px;
  padding: 2px;
}

.colorPreview {
  height: 24px;
  border-radius: 4px;
  margin: 0px 4px;
}

.annotationSeries {
  margin: 0px 24px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/reportobjectmenus/chart/chart.menu.tab.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".groupBorder {\n  border: 1px solid lightgray;\n  border-radius: 4px;\n  margin-bottom: 4px;\n  padding: 2px;\n}\n\n.colorPreview {\n  height: 24px;\n  border-radius: 4px;\n  margin: 0px 4px;\n}\n\n.annotationSeries {\n  margin: 0px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
